import React from "react";
import Table from "./Table/index";

export default function Contact() {
  return (
    <div>
      <Table />
    </div>
  );
}
